import { render, staticRenderFns } from "./ShopBrowser.vue?vue&type=template&id=35b5844c&scoped=true&"
import script from "./ShopBrowser.vue?vue&type=script&lang=ts&"
export * from "./ShopBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./ShopBrowser.vue?vue&type=style&index=0&id=35b5844c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b5844c",
  null
  
)

export default component.exports